if (typeof MobileId === 'undefined') {
	var MobileId;
}

MobileId = (function () {
	const PHONE_NO_INITIAL_VALUE = '+372';
	const POLLING_INTERVAL_MS = 5000;
	const MAX_POLLING_RETRY_COUNT = 18;

	// define events with IE11 fallback
	let eventAuthProcessStarted;
	let eventAuthProcessStopped;
	if (typeof window.CustomEvent === 'function') {
		eventAuthProcessStarted = new Event('authProcessStarted');
		eventAuthProcessStopped = new Event('authProcessStopped');
	}
	else {
		eventAuthProcessStarted = document.createEvent('Event');
		eventAuthProcessStarted.initEvent('authProcessStarted', true, false);
		eventAuthProcessStopped = document.createEvent('Event');
		eventAuthProcessStopped.initEvent('authProcessStopped', true, false);
	}

	function init() {
		const mobileIdContainer = document.querySelector('.js-mobile-id');
		mobileIdContainer.querySelector('.js-mobile-id-person-id').focus();
		bindEvents(mobileIdContainer);
	}

	function startMobileIdAuth(context) {
		let personId = context.querySelector('.js-mobile-id-person-id').value;
		let phoneNo = PHONE_NO_INITIAL_VALUE + context.querySelector('.js-mobile-id-phone-no').value;

		//if (personId.length < 11) {
		//	context.find('.js-mobile-id-person-id').putCursorAtEnd();
		//	return;
		//}

		//if (phoneNo.length < 5) {
		//	context.find('.js-mobile-id-phone-no').putCursorAtEnd();
		//	return;
		//}

		context.dispatchEvent(eventAuthProcessStarted);
		let url = document.querySelector('.js-mobile-id').dataset.authStartUrl;
		url = url + '?phoneNo=' + encodeURIComponent(phoneNo);
		url = url + '&personId=' + encodeURIComponent(personId);
		axios.get(url)
			.then(function (response) {
				mobileIdAuthStarted(response.data, context);
			})
			.catch(function (error) {
				showMessage(error.response.data.message, context, true);
				context.dispatchEvent(eventAuthProcessStopped);
			});
	}

	function mobileIdAuthStarted(startData, context) {
		if (startData.isSuccess) {
			showMessage('<div>' + startData.message.format('<div class="mobile-id-security-code">' + startData.securityCode + '</div>') + '</div>', context, false, true);
			pollAuthStatus(startData, 1, context);
		}
		else {
			showMessage(startData.message, context, true);
			context.dispatchEvent(eventAuthProcessStopped);
			context.querySelector('.js-mobile-id-person-id').focus();
		}
	}

	function pollAuthStatus(startData, retryCount, context) {
		if (retryCount > MAX_POLLING_RETRY_COUNT) {
			showMessage('Error during authentication. Please try again!', context, true);
			context.dispatchEvent(eventAuthProcessStopped);
			return;
		}

		axios.get('/account/login/mobileid/status?sessionId=' + startData.sessionId)
			.then(function (response) {
				mobileIdAuthStatusReceived(response.data, startData, retryCount, context);
			})
			.catch(function (error) {
				console.log(error);
				showMessage('Error during authentication. Please try again!', context, true);
				context.dispatchEvent(eventAuthProcessStopped);
			});
	}

	function mobileIdAuthStatusReceived(authStatus, startData, retryCount, context) {
		if (authStatus.isInProgress) {
			window.setTimeout(function () { pollAuthStatus(startData, retryCount++, context); }, POLLING_INTERVAL_MS);
		}
		else if (authStatus.isSuccess) {
			let url = document.querySelector('.js-mobile-id').dataset.authCallback;
			window.location.replace(url);
		}
		else {
			showMessage(authStatus.message, context, true);
			context.dispatchEvent(eventAuthProcessStopped);
		}
	}

	function showMessage(message, context, isError, hideForm) {
		const messageContainer = context.querySelector('.js-mobile-id-message');
		const formContainer = context.querySelector('.js-mobile-id-form');

		messageContainer.innerHTML = message;
		if (isError === true) {
			messageContainer.classList.add('mobile-id-message-error');
		}
		else {
			if (messageContainer.classList.contains('mobile-id-message-error')) {
				messageContainer.classList.remove('mobile-id-message-error');
			}
		}

		if (hideForm === true) {
			formContainer.style.display = 'none';
		}
		else {
			formContainer.style.display = '';
		}
		messageContainer.style.display = '';
	}

	function hideMessage(context) {
		context.querySelector('.js-mobile-id-message').style.display = 'none';
		context.querySelector('.js-mobile-id-form').style.display = '';
	}

	function bindEvents(context) {
		context.querySelector('.js-mobile-id-submit').addEventListener('click', function (event) {
			event.preventDefault();
			hideMessage(context);
			startMobileIdAuth(context);
		});
		context.querySelector('.js-mobile-id-cancel').addEventListener('click', function (event) {
			event.preventDefault();
			context.dispatchEvent(eventAuthProcessStopped);
			hideMessage(context);
			if (context.querySelector('.js-mobile-id-submit').disabled === false) {
				let url = document.querySelector('.js-mobile-id').dataset.authCancel;
				window.location.replace(url);
			}
		});
		context.addEventListener('authProcessStarted', function () {
			// forEach with the IE11 fallback
			let elementsToDisable = context.querySelectorAll('.js-mobile-id-person-id, .js-mobile-id-phone-no, .js-mobile-id-submit');
			Array.prototype.slice.call(elementsToDisable).forEach(function (element) {
				element.disabled = true;
			});
		});
		context.addEventListener('authProcessStopped', function () {
			// forEach with the IE11 fallback
			let elementsToEnable = context.querySelectorAll('.js-mobile-id-person-id, .js-mobile-id-phone-no, .js-mobile-id-submit');
			Array.prototype.slice.call(elementsToEnable).forEach(function (element) {
				element.disabled = false;
			});
		});
		context.querySelector('.js-mobile-id-person-id').addEventListener('keydown', event => {
			if (event.keyCode === 13) {
				event.preventDefault();
				context.querySelector('.js-mobile-id-submit').click();
				return;
			}
		});
		context.querySelector('.js-mobile-id-phone-no').addEventListener('keydown', event => {
			if (event.keyCode === 13) {
				event.preventDefault();
				context.querySelector('.js-mobile-id-submit').click();
				return;
			}
		});
	}

	return {
		init: init
	};
}());

MobileId.init();
